import { useDataTable } from 'hooks/useDataTable';
import { useState } from 'react';
import { Grid } from 'common/containers';
import DataTable from 'common/dataTable';
import Options from './options';
import { useIntl } from 'react-intl';
import Search from 'common/tableFilters/search';
import { formatNumber } from 'utils/formatData';
const PaymentMethodsTable = () => {
	const { formatMessage } = useIntl();
	const [refresh, setRefresh] = useState(1);
	const {
		response,
		isLoading,
		totalDocs,
		perPage,
		handlePageChange,
		handlePerRowsChange,
		search,
		setSearch,
		showHidden,
		setShowHidden,
	} = useDataTable('payment-methods', [{ name: null, value: null }], refresh);
	const columns = [
		{
			name: 'Tarjeta',
			selector: (row: any) => row.cardNumber,
			sortable: true,
			wrap: true,
		},
		{
			name: 'Banco',
			selector: (row: any) => row.bank,
			sortable: true,
			wrap: true,
		},
		{
			name: 'Balance',
			selector: (row: any) => `$${formatNumber(row.balance)}`,
			sortable: true,
			grow: 2,
			wrap: true,
		},
		{
			name: formatMessage({ id: 'table.options' }),
			cell: (row: any) => {
				return (
					<Options
						deleteItem={`/payment-methods/${row._id}`}
						edit={`/payment-methods/edit/${row._id}`}
						refresh={setRefresh}
					/>
				);
			},
		},
	];

	return (
		<>
			<Grid
				$columns={2}
				$separator="1rem">
				<Search
					search={search}
					setSearch={setSearch}
				/>
			</Grid>
			<DataTable
				data={response}
				columns={columns}
				progressPending={isLoading}
				pagination
				paginationServer
				paginationTotalRows={totalDocs}
				onChangeRowsPerPage={handlePerRowsChange}
				onChangePage={handlePageChange}
				paginationPerPage={perPage}
				toggleHidden={false}
				showHidden={showHidden}
				setShowHidden={setShowHidden}
			/>
		</>
	);
};
export default PaymentMethodsTable;
